import React, { Component } from 'react'
import { GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import { Box, SelectChangeEvent, Typography } from '@mui/material';
import { RouteComponentProps, RouterProps, generatePath } from 'react-router';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from '@mui/icons-material/Add';
import { visuallyHidden } from '@mui/utils';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { DateTime, Duration } from 'luxon';
import { appContext } from '../../../../AppContext';
import IbssActionButton, { IActionButton } from '../../../../Components/Buttons/ActionButton/IbssActionButton';
import IbssSvgIcon from '../../../../Components/Icons/SvgIcon/IbssSvgIcon';
import IbssDialog from '../../../../Components/Dialogs/BaseDialog/IbssDialog';
import IbssInputDropDown from '../../../../Components/Inputs/SelectList/IbssInputDropDown';
import IbssButtonRedo from '../../../../Components/Buttons/Button/IbssButton';
import IbssFilterHeader, { StartOrEnd } from '../../../../Components/Forms/DateRange/IbssFilterHeader';
import IbssFilter from '../../../../Components/Forms/Filter/IbssFilter';
import Spinner from '../../../../Components/Navigation/LoadingSpinner/Spinner';
import IbssTextField from '../../../../Components/Inputs/TextField/IbssTextField';
import { DateHelper } from '../../../../Common/DateHelper';
import { ITasksFilter } from '../../../../Providers.Api/Tasks/TaskRepository';
import BookingStatus, { Status } from '../../../../Components/Miscellaneous/BookingStatus/BookingStatus';
import TimeZoneOffset from '../../../../Components/Miscellaneous/TimeZoneOffset/TimeZoneOffset';
import TickIcon from '../../../../Components/Icons/TickIcon';
import { Space } from '../../../../Providers.Api/Spaces/SpaceRepository';
import UserPicker, * as UserPickerModule from '../../../../Components/Inputs/UserPicker/UserPicker';
import { QueryParams } from './QueryParams';
import { IbssPage } from '../../../../Components/Core/BasePage/IbssPage';
import { DateRangeHelper } from '../../../../Common/DateRangeHelper';
import { StringHelper } from '../../../../Common/StringHelper';
import { Constants } from '../../../../Common/Constants';
import { rights } from '../../../../Common/RightsManager';
import PreparingExportDialog from '../../../../Components/Dialogs/PreparingExportDialog/PreparingExportDialog';
import { ITaskView, Task } from './DataModels';
import { PagedResponse } from '../../../../Providers.Api/Models';
import ServerDataGrid, { DataGridQueryResult, IDataQuery, IPages } from '../../../../Components/Data/ServerDataGrid/ServerDataGrid';
import Helper from '../../../../Common/Helper';

export default class ListTasks extends IbssPage<IProps, IState, QueryParams>
{
    private get alert() { return appContext().alert; }
    private get labels() { return appContext().labels; }
    private get appState() { return appContext().state; }
    private get local() { return appContext().localStorageProvider; }
    private get apiClient() { return appContext().apiClient; }
    private get apiCache() { return appContext().apiCache; }
    private pageCacheKey = '424a425a-1cda-41e7-bb1a-2r9874ba4Cb4';
    private string = new StringHelper();
    private isFlex = this.area == 'flex';
    private dataGridRef = React.createRef<ServerDataGrid<ITaskView>>();
    private get dataGrid() { return this.dataGridRef.current; }

    private modalConstants: ITaskModal =
        {
            messageModal: "messageModal",
            userSelectionModal: "userSelectionModal",
            filterModal: "filterModal",
            priorityModal: "priorityModal"
        }

    private readonly actionType =
        {
            assign: "assign",
            setInProgress: "set-in-progress",
            cancel: "cancel",
            unassign: "unassign",
            reAllocate: "re-allocate",
            changePriority: "change-priority",
            resolve: "resolve",


        }
    constructor(props: IProps)
    {
        super(props, new QueryParams());

        this.state =
        {
            loading: false,
            buildingId: this.appState.buildingId,
            taskList: [],
            todayTaskList: [],
            canExport: false,
            isCreateRight: false,
            isUpdateRight: false,
            isAssignRight: false,
            isCancelRight: false,
            isChangePriorityRight: false,
            isReallocateRight: false,
            isSetInProgressRight: false,
            isUnAssignRight: false,
            buildingid: this.appState.buildingId,
            startDate: DateHelper.now(),
            endDate: DateHelper.now(),
            openUserModal: false,
            openMessageModal: false,
            message: "",
            selectedTaskIds: [],
            actionType: "",
            daysFilter: this.labels.HubLabelToday,
            dateDisabled: true,
            searchTerm: "",
            openFilterModal: false,
            statusValue: this.labels.HubLabelAssigned,
            disableReallocate: true,
            disableCancel: true,
            disableUnassign: true,
            disablePriority: true,
            disableInprogress: true,
            inProgressModal: false,
            userSearchText: "",
            selectedUser: { label: "", userName: "" },
            openPriorityModal: false,
            setPriority: 1,
            disableResolved: true,
            isAtleastOneInProgress: true,
            showPreparingExportPopup: false,
            disableExport: false,
            pagesOfTask:
            {
                pages: [],
                pageIndex: 0,
                skipToken: '',
            },
        }
    }

    public async queryParamsDidUpdate(firstLoad: boolean, prevParams: QueryParams): Promise<void>
    {
        const queryParams = this.queryParams;
        this.pageTitle = (this.isFlex ? this.labels.HubLabelMyTask : this.labels.HubMenuTasks);

        if (firstLoad)
        {
            this.clearCache();
        }
        
        if (!queryParams.building)
        {
            return this.pushQueryParams({ building: this.appState.buildingId }, true);
        }
        else if (!queryParams.status)
        {
            return this.pushQueryParams({ status: 'Any' }, true);
        }

        const dateRange = new DateRangeHelper(queryParams.building || 1)
            .addToday()
            .addTomorrow()
            .addThisWeek()
            .addNextWeek()
            .addThisMonth()
            .addNextMonth()
            .addLastMonth()
            .getDateRange(queryParams.period, this.labels.HubLabelToday, queryParams.start, queryParams.end);

        if (dateRange.isPeriodCustom && (queryParams.period != undefined || queryParams.start != dateRange.start || queryParams.end != dateRange.end))
        {
            return this.pushQueryParams({ period: undefined, start: dateRange.start, end: dateRange.end }, true);
        }
        else if (!dateRange.isPeriodCustom && (queryParams.period != dateRange.period || queryParams.start != undefined || queryParams.end != undefined))
        {
            return this.pushQueryParams({ period: dateRange.period, start: undefined, end: undefined }, true);
        }

        await this.setStateAsync({
            buildingId: queryParams.building || 1,
            daysFilter: dateRange.period,
            dateDisabled: !dateRange.isPeriodCustom,
            startDate: dateRange.start,
            endDate: dateRange.end,
            searchTerm: queryParams.filter || '',
            statusValue: queryParams.status || '',
        });

        this.setRights();
        await this.dataGrid?.refresh();
    }

    private clearCache(): void
    {
        appContext().inMemoryCache.clear(i => i.startsWith(this.pageCacheKey + '_'));
    }

    private setRights(): void
    {
        this.setState({ canExport: rights.API.Tasks.Export.has() });

        if (rights.ADMINPORTAL.Tasks.Create.has())
        {
            this.setState({ isCreateRight: true });
        }
        if (rights.ADMINPORTAL.Tasks.Update.has())
        {
            this.setState({ isUpdateRight: true });
        }
        if (rights.ADMINPORTAL.Tasks.Assign.has())
        {
            this.setState({ isAssignRight: true });
        }
        if (rights.ADMINPORTAL.Tasks.Unassign.has())
        {
            this.setState({ isUnAssignRight: true });
        }
        if (rights.ADMINPORTAL.Tasks.Cancel.has())
        {
            this.setState({ isCancelRight: true });
        }
        if (rights.ADMINPORTAL.Tasks.Reallocate.has())
        {
            this.setState({ isReallocateRight: true });
        }
        if (rights.ADMINPORTAL.Tasks.SetInProgress.has())
        {
            this.setState({ isSetInProgressRight: true });
        }
        if (rights.ADMINPORTAL.Tasks.ChangePriority.has())
        {
            this.setState({ isChangePriorityRight: true });
        }
    }

    private getSpacesByIds(spaces: Space[], delimitedSpaceIds: string): Space[]
    {
        const taskSpaces = delimitedSpaceIds.split(";").map(id => spaces.find(space => space.Space_Id === id)).filter(space => space != null) as Space[];
        return taskSpaces;
    }

    private async dataQueryChanged(gridQuery: IDataQuery): Promise<DataGridQueryResult<ITaskView>>    
    {
        try
        {
            this.setState({ loading: true });
            let email = this.local.getUserDetails().email;
            const { statusValue, startDate, endDate, buildingId, daysFilter } = this.state;
            let filter: ITasksFilter =
            {
                status: statusValue === "Any" ? undefined : statusValue,
                createdFrom: startDate.startOf('day').toUtcByNode(buildingId),
                createdTo: endDate.endOf('day').toUtcByNode(buildingId),
            };

            if (this.isFlex)
            {
                if (statusValue != 'Active' && statusValue != 'Awaiting Re-allocation')
                {
                    filter.createdBy = email;
                }
            }

            filter = this.isFlex ? { ...filter, createdBy: email } : filter;
            let filterParts = new Array<string>();
            filter.taskStatusNot?.map((item) => filterParts.push(`Task_Status ne '${item}'`));
            filterParts.push(filter.createdBy ? `CreatedBy eq '${filter.createdBy.toLocaleLowerCase()}'` : "");
            filterParts.push(filter.status ? `Task_Status eq '${filter.status}'` : "");
            filterParts.push(filter.createdFrom ? `Task_Due_Date ge datetime'${filter.createdFrom.toUtcByNode(buildingId).toISO()}'` : "");
            filterParts.push(filter.createdTo ? `Task_Due_Date le datetime'${filter.createdTo.toUtcByNode(buildingId).toISO()}'` : "");
            filterParts.push('Space_Id ne null');
            const filterString = filterParts.filter(i => i != "").join(" and ");
            const taskEndpoint =
            {
                name: 'ibssApiClientV2.v2.byNodeid.tasks.get',
                options:
                {
                    nodeId: this.isFlex ? 1 : buildingId,
                    recursive: true,
                    select: Task,
                    filter: filterString,
                    skipToken: gridQuery.skipToken,
                    top: 100
                }

            }
            let response = await appContext().inMemoryCache.lazyGetWithQuickExpiry
                (
                    `${this.pageCacheKey}_${JSON.stringify(taskEndpoint)}`,
                    () => appContext().ibssApiClientV2.v2.byNodeid.tasks.get<PagedResponse<Task[]>>
                        (
                            taskEndpoint.options
                        )
                )
            const spaces = await this.apiCache.getSpacesByBuilding(buildingId);
            let tasks: ITaskView[] = response.value.filter(item => item.Space_Id !== null).map(item =>
            {
                const taskEventTime = DateTime.fromISO(item.Task_Event_Time.toString());
                const createdAt = DateTime.fromISO(item.CreatedAt);
                const diff = taskEventTime.diff(createdAt, 'minutes').toObject().minutes || 0;
                const duration = Duration.fromMillis(diff * 60 * 1000);
                const timeDiff = duration.as('hours');
                const minuteDiff = duration.minutes % 60;
                const resolutionTime = `${Math.floor(timeDiff)} hrs ${minuteDiff ? minuteDiff + ' min' : ''}`;
                const spaceNames = this.getSpacesByIds(spaces, item.Space_Id).map(i => i.Space_Name);

                return ({
                    id: item.Task_Id,
                    Task_MinutesRemaining: resolutionTime,
                    spaceNames: spaceNames,
                    ...item,
                    Task_Event_Time: item.Task_Event_Time.toISO(),
                    Task_Due_Date: item.Task_Due_Date.toISO(),
                }) as ITaskView;

            });
            this.setState({ taskList: tasks, loading: false });
            if (daysFilter === this.labels.HubLabelToday)
            {
                this.setState({ todayTaskList: tasks });
            }
            return new DataGridQueryResult(tasks, response.skipToken);
        }
        finally
        {
            this.setState({ loading: false });
        }
    }

    private async dateRangeChanged(e: SelectChangeEvent<string>): Promise<void>
    {
        const period = this.string.toKebabCase(e.target.value);
        const customPeriod = this.string.toKebabCase(this.labels.HubLabelCustom);
        const periodIsCustom = (period == customPeriod);

        this.pushQueryParams({
            period: (periodIsCustom ? undefined : period),
            start: (periodIsCustom ? this.state.startDate : undefined),
            end: (periodIsCustom ? this.state.endDate : undefined),
        });
    }

    private async startDateChanged(e: DateTime): Promise<void>
    {
        this.pushQueryParams({ start: e });
    }

    private async endDateChanged(e: DateTime): Promise<void>
    {

        this.pushQueryParams({ end: e });
    }

    private actionClicked(type: string): void
    {
        if (type === this.actionType.cancel || type === this.actionType.unassign)
        {
            this.setState({
                openMessageModal: true,
                actionType: type,
                message: "",
            });
        }
        if (type === this.actionType.reAllocate)
        {
            this.setState({
                openUserModal: true,
                actionType: type
            });
        }
        if (type === this.actionType.changePriority)
        {
            this.setState({
                openPriorityModal: true,
                actionType: type,
            });
        }
        if (type === this.actionType.setInProgress)
        {
            this.setState({
                openMessageModal: true,
                actionType: type,
                inProgressModal: true,
            });
        }
        if (type === this.actionType.resolve)
        {
            this.setState({
                openMessageModal: true,
                actionType: type,
                disableResolved: true,
            })
        }
    }

    private gridActionClicked(status: string, taskId: string): void
    {
        if (status === this.labels.HubButtonAssign)
        {
            this.setState({
                openUserModal: true,
                selectedTaskIds: [taskId],
                actionType: this.actionType.assign
            })
        }
        if (status === this.labels.HubButtonSetInProgress)
        {
            this.setState({
                openMessageModal: true,
                selectedTaskIds: [taskId],
                actionType: this.actionType.setInProgress
            })
        }
        if (status === this.labels.HubLabelResolved)
        {
            this.setState({
                openMessageModal: true,
                selectedTaskIds: [taskId],
                actionType: this.actionType.resolve
            })
        }
    }

    private messagePopupChanged(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void
    {
        this.setState({ message: e.target.value });
    }

    private async userPopupChanged(newValue: UserPickerModule.IUser | null): Promise<void>
    {
        if (newValue)
        {
            this.setState({ selectedUser: { label: newValue.label, userName: newValue.userName } })
        }
        else
        {
            this.setState({ selectedUser: { label: "", userName: "" } })
        }
    }

    private popupClose(type: string): void
    {
        if (type === this.modalConstants.messageModal)
        {
            this.setState({
                openMessageModal: false,
            })
        }
        if (type === this.modalConstants.filterModal)
        {
            this.setState({
                openFilterModal: false,
            })
        }
        if (type === this.modalConstants.userSelectionModal)
        {
            this.setState({
                openUserModal: false,
            })
        }
        if (type === this.modalConstants.priorityModal)
        {
            this.setState({
                openPriorityModal: false,
            })
        }
        this.setState({ loading: false });
    }

    private popupCancelled(type: string): void
    {
        if (type === this.modalConstants.priorityModal)
        {
            this.setState({
                openPriorityModal: !this.state.openPriorityModal,
                message: ""
            })
        }
        if (type === this.modalConstants.messageModal)
        {
            this.setState({
                openMessageModal: !this.state.openMessageModal,
                message: ""
            })
        }
        if (type === this.modalConstants.filterModal)
        {
            this.setState({
                openFilterModal: !this.state.openFilterModal,
            })
            this.pushQueryParams({
                status: this.state.statusValue
            })
        }
        if (type === this.modalConstants.userSelectionModal)
        {
            this.setState({
                openUserModal: !this.state.openUserModal,
                selectedUser: { label: "", userName: "" }
            })
        }
        this.setState({ loading: false });
    }

    private messagePopupSubmitted(): Promise<void>
    {
        return (this.state.inProgressModal ? this.setInProgressForManyTasks(this.modalConstants.messageModal) : this.popupSubmitted(this.modalConstants.messageModal));
    }

    private async popupSubmitted(type: string): Promise<void>
    {
        this.setState({ loading: true });
        let message = "";
        let apiPayload = {};

        if (type === this.modalConstants.filterModal)
        {
            this.popupClose(type);
            this.pushQueryParams({ status: this.state.statusValue })
            return;
        }


        if (type === this.modalConstants.messageModal || type === this.modalConstants.priorityModal || type === this.modalConstants.userSelectionModal)
        {
            const promises = this.state.selectedTaskIds.map(async (id: number | string) =>
            {
                const selectedTaskNodeId = this.state.taskList.find((task:ITaskView) => task.Task_Id === Number(id))?.Node_Id
                let response;
                if(selectedTaskNodeId)
                {
                    if (type === this.modalConstants.messageModal)
                    {
                        // preparing API payload for messageModal
                        if (this.state.actionType == 'cancel')
                        {
                            const body =
                            {
                                DisableExtUpdate: true,
                                TaskResolveDescription: this.state.message
                            }
                            response = await appContext().ibssApiClientV2.v2.byNodeid.tasks.byId.cancel.delete({ nodeId: selectedTaskNodeId, id: Number(id), body: body })
                        }
                        else
                        {
                            if (type === this.modalConstants.messageModal)
                            {
                                apiPayload = {
                                    message: this.state.message,
                                }
                            }
                            if (this.state.actionType === this.actionType.resolve)
                            {
                                apiPayload = {
                                    TaskResolveDescription: this.state.message,
                                }
                                response = await appContext().ibssApiClientV2.v2.byNodeid.tasks.byId.resolve.patch(
                                    {
                                        nodeId: selectedTaskNodeId,
                                        id: id.toString(),
                                        body: apiPayload
                                    });
                            }
                            else if (this.state.actionType === this.actionType.unassign)
                            {
                                response = await appContext().ibssApiClientV2.v2.byNodeid.tasks.byId.unassign.patch(
                                    {
                                        nodeId: selectedTaskNodeId,
                                        id: id.toString(),
                                    });
                                await appContext().ibssApiClientV2.v2.byNodeid.tasks.byId.comment.patch({
                                    nodeId: selectedTaskNodeId,
                                    id: id.toString(),
                                    body: { Message: this.state.message },
                                });
                            }
                            else if (this.state.actionType === this.actionType.setInProgress)
                            {
                                response = await appContext().ibssApiClientV2.v2.byNodeid.tasks.byId.setInProgress.patch(
                                    {
                                        nodeId: selectedTaskNodeId,
                                        id: id.toString(),
                                    });
                                if (response && this.state.message !== "")
                                {
                                    response = await appContext().ibssApiClientV2.v2.byNodeid.tasks.byId.comment.patch({
                                        nodeId: selectedTaskNodeId,
                                        id: id.toString(),
                                        body: { Message: this.state.message },
                                    });
                                }
                            }
                        }
                    }
                    if (type === this.modalConstants.priorityModal)
                    {
                        // preparing API payload for priority
                        if (type === this.modalConstants.priorityModal)
                        {
                            apiPayload = {
                                "priority": this.state.setPriority,
                            }
                        }
                        response = await appContext().ibssApiClientV2.v2.byNodeid.tasks.byId.changePriority.patch({ nodeId: selectedTaskNodeId, id: id.toString(), body: apiPayload })
                    }
                    if (type === this.modalConstants.userSelectionModal)
                    {
                        // preparing API payload for userSelection
                        if (type === this.modalConstants.userSelectionModal)
                        {
                            if (this.state.actionType === this.actionType.reAllocate)
                            {
                                apiPayload = {
                                    "resolver_id": this.state.selectedUser.userName,
                                    "priority": 1,
                                }
                                response = await appContext().ibssApiClientV2.v2.byNodeid.tasks.byId.reAllocate.patch({ nodeId: selectedTaskNodeId, id: id.toString(), body: apiPayload })
                            }
                            if (this.state.actionType === this.actionType.assign)
                            {
                                apiPayload = {
                                    "resolver_id": this.state.selectedUser.userName,
                                }
                                response = await appContext().ibssApiClientV2.v2.byNodeid.tasks.byId.assign.patch({ nodeId: selectedTaskNodeId, id: id.toString(), body: apiPayload })
                            }
                        }
                    }
                }
                if (response)
                {
                    this.popupClose(type);
                    return Promise.resolve(response);
                }
                else
                {
                    return Promise.reject(new Error(`Failed to delete resource with ID ${id}`));
                }
            });

            Promise.all(promises)
                .then(() =>
                {
                    // All responses are okay, hide the modal
                    this.alert.show("", message);
                    this.clearCache();
                    this.dataGrid?.refresh();
                    this.popupClose(type);
                })
                .catch(() =>
                {
                    this.setState({ loading: false });
                    this.popupCancelled(type);
                });
        }
    }

    private async setInProgressForManyTasks(type: string): Promise<void>
    {
        this.setState({ openMessageModal: false, loading: true });
        let successMessage = "";

        const promises = this.state.selectedTaskIds.map(async resourceId =>
        {
            const selectedTaskNodeId = this.state.taskList.find((task) => task.Task_Id == resourceId)?.Node_Id
            let response;
            if (selectedTaskNodeId)
            {
                response = await appContext().ibssApiClientV2.v2.byNodeid.tasks.byId.setInProgress.patch({ nodeId: selectedTaskNodeId, id: resourceId.toString() });
                await appContext().ibssApiClientV2.v2.byNodeid.tasks.byId.comment.patch({
                    nodeId: selectedTaskNodeId,
                    id: resourceId.toString(),
                    body: { Message: this.state.message },
                });
            }

            if (response)
            {
                this.setState({ loading: false });
                return Promise.resolve(response);
            }
            else
            {
                this.setState({ loading: false });
                return Promise.reject(new Error(`Failed to delete with ID ${resourceId}`));
            }
        });

        try
        {
            const responses = await Promise.all(promises);
            this.alert.show("", successMessage);
            this.clearCache();
            this.setState({ selectedTaskIds: [] });
            await this.dataGrid?.refresh();
        }
        finally
        {
            this.setState({ loading: false });
        }
    }

    private tasksSelected(selection: GridRowSelectionModel)
    {
        this.setState({ selectedTaskIds: selection });
        const selectedRows = this.filterTasks(this.state.searchTerm).pages.flatMap(page => page.rows).filter((row: ITaskView) => selection.includes(row.Task_Id));
        const cancelRows = new Array<ITaskView>();
        const inProgressTasks = new Array<ITaskView>();
        const hasResolvedTask: boolean = selectedRows.some((row: ITaskView) => row.Task_Status === "Resolved");


        for (let i = 0; i <= selectedRows.length - 1; i++)
        {
            const status = selectedRows[i]["Task_Status"]
            if (status === "Active" || status === "Assigned" || status === "In Progress" || status === "Awaiting Re-allocation")
            {
                cancelRows.push(selectedRows[i]);
            }
        }

        if (selectedRows.length <= 0 && cancelRows.length <= 0)
        {
            this.setState({ disableCancel: true });
        }
        else if (selectedRows.length === cancelRows.length && this.state.isCancelRight)
        {
            this.setState({ disableCancel: false });
        }
        else
        {
            this.setState({ disableCancel: true });
        }

        for (let i = 0; i <= selectedRows.length - 1; i++)
        {
            const status = selectedRows[i]["Task_Status"];
            if (status === "Assigned")
            {
                inProgressTasks.push(selectedRows[i])
            }
        }

        if (selectedRows.length <= 0 && inProgressTasks.length <= 0)
        {
            this.setState({ disableInprogress: true });
        }
        else if (selectedRows.length === inProgressTasks.length && this.state.isSetInProgressRight)
        {
            this.setState({ disableInprogress: false });
        }
        else
        {
            this.setState({ disableInprogress: true });
        }

        // disable the change Priority button
        if (selection.length !== 0 && this.state.isChangePriorityRight && !hasResolvedTask)
        {
            this.setState({ disablePriority: false });
        }
        else
        {
            this.setState({ disablePriority: true });
        }

        const list = selection.map((id: number | string) => this.state.taskList.find((el: ITaskView) => el.Task_Id == id));
        const unAssigned: boolean = list.length ? list.some((e: any) => e.Task_Owner === "") : true
        const reallocate: boolean = list?.length > 0 ? list?.some((e: any) => e.Task_Status !== this.labels.HubLabelReAllocation) : true

        if (!reallocate && this.state.isReallocateRight)
        {
            this.setState({ disableReallocate: false });
        }
        else
        {
            this.setState({ disableReallocate: true });
        }


        // disable the unassign button
        if (!unAssigned && this.state.isUnAssignRight && !hasResolvedTask)
        {
            this.setState({ disableUnassign: false });
        } else
        {
            this.setState({ disableUnassign: true });
        }

        const isAtleastOneInProgress = selectedRows.some((row: ITaskView) => row.Task_Status === "In Progress");
        this.setState({ isAtleastOneInProgress });

        if (selection.length > 0)
        {
            this.setState({ disableResolved: !isAtleastOneInProgress });

        } else
        {
            this.setState({ disableResolved: true });
        }

    }

    private filterTasks(searchTerm: string): IPages<ITaskView>
    {
        const filteredTasks = this.state.taskList.filter(task =>
        {
            let key: keyof ITaskView;
            for (key in task)
            {
                if (task[key]?.toString().includes(searchTerm))
                {
                    return true;
                }
            }
            return false;
        });
        return { pages: [{ rows: filteredTasks }], skipToken: '', pageIndex: 0 }
    }

    private debounceFilterTextTimer: NodeJS.Timeout | null = null;
    private searchTermChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void
    {
        this.setState({ searchTerm: event.target.value });
        clearTimeout(this.debounceFilterTextTimer ?? undefined);
        this.debounceFilterTextTimer = setTimeout(() => this.pushQueryParams({ filter: event.target.value }), Constants.longDebounceTimeInMilliseconds);
    }

    private async exportTaskList(): Promise<void>
    {
        this.setState({ disableExport: true, showPreparingExportPopup: true });
        setTimeout(() => this.setState({ disableExport: false }), 60000);

        const filter = {
            Node_Id: this.state.buildingId,
            Filter: `${this.state.statusValue !== "Any" ? `status eq '${this.state.statusValue}' and ` : ''}createdFrom eq '${this.state.startDate.startOf('day').toUtcByNode(this.state.buildingId)}' and createdTo eq '${this.state.endDate.endOf('day').toUtcByNode(this.state.buildingId)}'`,
            Source: "oneLens"
        };
        try
        {
            await appContext().ibssApiClientV2.v2.byNodeid.tasks.download.post({
                nodeId: this.state.buildingId,
                body: filter
            });
        } 
        catch
        {

        }
    }


    private navigateToAddTask(): void
    {
        const { history } = this.props;
        if (this.isFlex)
        {
            history.push(`/flex-my-tasks/${this.state.buildingid}/mytask/0`);
        }
        else
        {
            history.push(`/operational-services-tasks/${this.state.buildingid}/task/0/1`);
        }
    }


    public render(): JSX.Element
    {
        const dataGridHeader: GridColDef<ITaskView>[] =
            [
                {
                    headerName: this.labels.HubLabeltaskType,
                    field: Helper.nameOf<ITaskView>("Task_Type_Name"),
                    minWidth: 130,
                    flex: 1,
                    sortable: false,
                },
                {
                    headerName: this.labels.HubLabelCategory,
                    field: Helper.nameOf<ITaskView>("Task_Category_Name"),
                    minWidth: 130,
                    flex: 1,
                    sortable: false,
                },
                {
                    headerName: this.labels.HubLabelLocation,
                    field: Helper.nameOf<ITaskView>("spaceNames"),
                    minWidth: 130,
                    flex: 1,
                    sortable: false,
                },
                {
                    headerName: this.labels.HubLabelPriorityLabel,
                    field: Helper.nameOf<ITaskView>("Task_Priority"),
                    minWidth: 130,
                    flex: 1,
                    sortable: false,
                    renderCell: (params) => this.renderTaskPriority(params.row.Task_Priority),
                },
                {
                    headerName: this.labels.HubLabelDueDate,
                    field: Helper.nameOf<ITaskView>("Task_Due_Date"),
                    minWidth: 140,
                    flex: 1,
                    sortable: false,
                    renderCell: (params) => params.row.Task_Due_Date == null ? '-' : DateTime.fromISO(params.row.Task_Due_Date).toLocaleDateTimeString(),
                },
                {
                    headerName: this.labels.HubLabelresolutionTimeLabel,
                    field: Helper.nameOf<ITaskView>("Task_TTC"),
                    minWidth: 150,
                    flex: 1,
                    sortable: false,
                    renderCell: (params) => 
                    {
                        if (params.row.Task_Status == 'Resolved')
                        {
                            const createDateTime = DateTime.fromISO(params.row.CreatedAt);
                            const resolutionTime = createDateTime.plus({ seconds: params.row.Task_TTC });
                            return resolutionTime.toLocaleDateTimeString();
                        }
                        else
                        {
                            return '-';
                        }
                    }

                },
                {
                    headerName: this.labels.HubLabelTimeZone,
                    cellClassName: "table-cell-font",
                    field: Helper.nameOf<ITaskView>("timeZone"),
                    minWidth: 140,
                    sortable: false,
                    renderCell: (params) => <TimeZoneOffset nodeId={params.row.Node_Id}
                    />
                },
                {
                    headerName: this.labels.HubLabelCreatedBy,
                    field: Helper.nameOf<ITaskView>("Task_CreatedBy"),
                    minWidth: 150,
                    flex: 1,
                    sortable: false,
                },
                {
                    headerName: this.labels.HubLabelResolver,
                    field: Helper.nameOf<ITaskView>("Task_Owner"),
                    minWidth: 150,
                    flex: 1,
                    sortable: false,
                },
                {
                    headerName: this.labels.HubLabelAction,
                    field: "",
                    minWidth: 140,
                    flex: 1,
                    filterable: false,
                    sortable: false,
                    renderCell: (params) => this.renderTaskAction(params.row.Task_Status, params.row.Task_Id.toString(), params.row.Node_Id.toString())
                },
                {
                    headerName: this.labels.HubLabelStatus,
                    field: Helper.nameOf<ITaskView>("Task_Status"),
                    minWidth: 130,
                    flex: 1,
                    sortable: false,
                    renderCell: (params) => <BookingStatus status={params.row.Task_Status as Status} />
                },
            ];

        const taskRaisedGridHeader: GridColDef<ITaskView>[] =
            [
                {
                    headerName: this.labels.HubLabelTask,
                    field: Helper.nameOf<ITaskView>("Task_Id"),
                    minWidth: 100,
                    flex: 1,
                },
                {
                    headerName: this.labels.HubLabeltaskType,
                    field: Helper.nameOf<ITaskView>("Task_Type_Name"),
                    minWidth: 120,
                    flex: 1,
                },
                {
                    headerName: this.labels.HubLabelCategory,
                    field: Helper.nameOf<ITaskView>("Task_Category_Name"),
                    minWidth: 140,
                    flex: 1,
                },
                {
                    headerName: this.labels.HubLabelLocation,
                    field: Helper.nameOf<ITaskView>("spaceNames"),
                    minWidth: 130,
                    flex: 1,
                },
                {
                    headerName: this.labels.HubLabelPriorityLabel,
                    field: Helper.nameOf("Task_Priority"),
                    minWidth: 100,
                    flex: 1,
                    renderCell: (params) => this.renderTaskPriority(params.row.Task_Priority),
                },
                {
                    headerName: this.labels.HubLabelDueDate,
                    field: Helper.nameOf("Task_Due_Date"),
                    minWidth: 150,
                    flex: 1,
                    renderCell: (params) => params.row.Task_Due_Date == null ? '-' : DateTime.fromISO(params.row.Task_Due_Date).toLocaleDateTimeString(),
                },
                {
                    headerName: this.labels.HubLabelAction,
                    field: "",
                    minWidth: 150,
                    flex: 1,
                    renderCell: (params) => this.renderTaskAction(params.row.Task_Status, params.row.Task_Id.toString(), params.row.Node_Id.toString())
                },
                {
                    headerName: this.labels.HubLabelStatus,
                    field: Helper.nameOf<ITaskView>("Task_Status"),
                    minWidth: 120,
                    flex: 1,
                    renderCell: (params) => <BookingStatus status={params.row.Task_Status as Status} />
                },
            ];

        // filter status options
        let filterStatusOption =
            [
                { label: this.labels.HubLabelAssigned, value: "Assigned" },
                { label: this.labels.HubLabelUnassigned, value: "Active" },
                { label: this.labels.HubLabelInProgress, value: "In Progress" },
                { label: this.labels.HubLabelCancelled, value: "Cancelled" },
                { label: this.labels.HubLabelResolved, value: "Resolved" },
                { label: this.labels.HubLabelReAllocation, value: "Awaiting Re-allocation" },
            ].sort((a, b) =>
            {
                var textA = a.label.toUpperCase();
                var textB = b.label.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });

        filterStatusOption = [{ label: this.labels.HubLabelAny, value: "Any" }, ...filterStatusOption]

        // priority options
        const priorityOption =
            [
                { label: this.labels.HubLabelHighPriority, value: 1 },
                { label: this.labels.HubLabelNormalPriority, value: 2 },
                { label: this.labels.HubLabelLowPriority, value: 3 },
            ]

        // Action buttons
        const actionButtons: IActionButton[] =
            [
                {
                    label: this.labels.HubButtonCancel,
                    icon: (
                        <IbssSvgIcon>
                            <DeleteIcon />
                        </IbssSvgIcon>
                    ),
                    color: "error",
                    onClick: () => this.actionClicked(this.actionType.cancel),
                    disabled: this.state.disableCancel
                },
                {
                    label: this.labels.HubButtonReallocate,
                    icon: (
                        <IbssSvgIcon>
                            <EditIcon />
                        </IbssSvgIcon>
                    ),
                    color: "info",
                    onClick: () => this.actionClicked(this.actionType.reAllocate),
                    disabled: this.state.disableReallocate
                },
                {
                    label: this.labels.HubButtonUnAssign,
                    icon: (
                        <IbssSvgIcon>
                            <EditIcon />
                        </IbssSvgIcon>
                    ),
                    color: "inherit",
                    onClick: () => this.actionClicked(this.actionType.unassign),
                    disabled: this.state.disableUnassign,
                },
                {
                    label: this.labels.HubButtonChangePriority,
                    icon: (
                        <IbssSvgIcon>
                            <PriorityHighIcon />
                        </IbssSvgIcon>
                    ),
                    color: "warning",
                    onClick: () => this.actionClicked(this.actionType.changePriority),
                    disabled: this.state.disablePriority,
                },
                {
                    label: this.labels.HubButtonSetInProgress,
                    icon: (
                        <IbssSvgIcon>
                            <PriorityHighIcon />
                        </IbssSvgIcon>
                    ),
                    color: "warning",
                    onClick: () => this.actionClicked(this.actionType.setInProgress),
                    disabled: this.state.disableInprogress,
                },
                {
                    label: this.labels.HubButtonAdd,
                    icon: (
                        <IbssSvgIcon>
                            <AddIcon />
                        </IbssSvgIcon>
                    ),
                    color: "primary",
                    onClick: () => this.navigateToAddTask(),
                    disabled: !this.state.isCreateRight
                },
                {
                    label: this.labels.HubLabelResolved,
                    icon: (
                        <IbssSvgIcon>
                            <TickIcon />
                        </IbssSvgIcon>
                    ),
                    color: "success",
                    onClick: () => this.actionClicked(this.actionType.resolve),
                    disabled: this.state.disableResolved || !this.state.isAtleastOneInProgress,
                }
            ];

        const taskRaisedActionButtons: IActionButton[] =
            [

                {
                    label: this.labels.HubButtonCancel,
                    icon: (
                        <IbssSvgIcon>
                            <DeleteIcon />
                        </IbssSvgIcon>
                    ),
                    color: "error",
                    onClick: () => this.actionClicked(this.actionType.cancel),
                    disabled: this.state.disableCancel
                },
                {
                    label: this.labels.HubButtonChangePriority,
                    icon: (
                        <IbssSvgIcon>
                            <PriorityHighIcon />
                        </IbssSvgIcon>
                    ),
                    color: "warning",
                    onClick: () => this.actionClicked(this.actionType.changePriority),
                    disabled: this.state.disablePriority,
                },
                {
                    label: this.labels.HubButtonAdd,
                    icon: (
                        <IbssSvgIcon>
                            <AddIcon />
                        </IbssSvgIcon>
                    ),
                    color: "primary",
                    onClick: () => this.navigateToAddTask(),
                    disabled: !this.state.isCreateRight
                }
            ];


        const filteredTasks = this.filterTasks(this.state.searchTerm);
        return (
            <>
                <div>
                    <PreparingExportDialog open={this.state.showPreparingExportPopup} onClose={() => this.setState({ showPreparingExportPopup: false })} />

                    {/* Modal for Set In Progress */}
                    <IbssDialog
                        aria-modal="true"
                        aria-label="set in progress modal"
                        open={this.state.openMessageModal}
                        onClose={() => this.popupCancelled(this.modalConstants.messageModal)}
                        fullWidth
                        header={this.labels.HubLabelMessageBox}
                        dialogContent=
                        {
                            <>
                                <label>{this.labels.HubLabelMessage}</label>
                                <IbssTextField
                                    sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                                    type="text"
                                    name="message"
                                    className="mt-1"
                                    fullWidth
                                    value={this.state.message}
                                    onChange={(e) => { this.messagePopupChanged(e) }}
                                />
                            </>
                        }
                        footer=
                        {
                            <Box gap={2} display={'flex'}>
                                <IbssButtonRedo
                                    color="secondary"
                                    variant="outlined"
                                    onClick={() => this.popupCancelled(this.modalConstants.messageModal)}
                                >
                                    {this.labels.HubButtonCancel}
                                </IbssButtonRedo>
                                <IbssButtonRedo
                                    color='primary'
                                    variant='contained'
                                    onClick={() => this.messagePopupSubmitted()}
                                >
                                    {this.labels.HubLabelOk}
                                </IbssButtonRedo>
                            </Box>
                        }
                    />
                    {/* User Selection Modal */}
                    <IbssDialog
                        aria-modal="true"
                        aria-label="user selection modal"
                        open={this.state.openUserModal}
                        onClose={() => this.popupCancelled(this.modalConstants.userSelectionModal)}
                        header={this.labels.HubLabelUserSelection}
                        fullWidth
                        dialogContent=
                        {
                            <>
                                <label>{this.labels.HubLabelnameEmailAddress}</label>
                                <UserPicker
                                    searchText={this.state.userSearchText}
                                    onChange={async text => this.setState({ userSearchText: text })}
                                    onUserChange={user => this.userPopupChanged(user)}
                                />
                            </>
                        }
                        footer=
                        {
                            <>
                               <Box gap={2} display={'flex'}>
                                    <IbssButtonRedo
                                        className="mr-2"
                                        color='secondary'
                                        variant='outlined'
                                        onClick={() => this.popupCancelled(this.modalConstants.userSelectionModal)}
                                    >
                                        {this.labels.HubButtonCancel}
                                    </IbssButtonRedo>
                                    <IbssButtonRedo
                                        color="primary"
                                        variant='contained'
                                        disabled={!this.state.selectedUser.userName}
                                        onClick={() => this.popupSubmitted(this.modalConstants.userSelectionModal)}
                                    >
                                        {this.labels.HubLabelOk}
                                    </IbssButtonRedo>
                                </Box>
                            </>
                        }
                    />
                    {/* Priority Modal */}
                    <IbssDialog
                        aria-modal="true"
                        aria-label="change priority modal"
                        open={this.state.openPriorityModal}
                        onClose={() => this.popupCancelled(this.modalConstants.priorityModal)}
                        fullWidth
                        header={this.labels.HubLabelPriorityLabel}
                        dialogContent=
                        {
                            <>
                                <div className="dropdown-selector">
                                    <IbssInputDropDown
                                        id="prioritySelect"
                                        options={priorityOption}
                                        value={this.state.setPriority}
                                        onChange={(e: SelectChangeEvent<string>) => this.setState({ setPriority: parseInt(e.target.value) })}
                                        inputLabel={this.labels.HubLabelSetPriority}
                                    />
                                </div>
                            </>
                        }
                        footer=
                        {
                            <>
                                <Box display={'flex'} justifyContent={'center'} gap={2}>
                                    <IbssButtonRedo
                                        color="secondary"
                                        variant="outlined"
                                        onClick={() => this.popupCancelled(this.modalConstants.priorityModal)}
                                    >
                                        {this.labels.HubButtonCancel}
                                    </IbssButtonRedo>
                                    <IbssButtonRedo variant='contained'
                                        onClick={() => this.popupSubmitted(this.modalConstants.priorityModal)}
                                    >
                                        {this.labels.HubLabelOk}
                                    </IbssButtonRedo>
                                </Box>
                            </>
                        }
                    />
                    {/* Filter Modal */}
                    <IbssDialog
                        aria-modal="true"
                        aria-label="filter modal"
                        open={this.state.openFilterModal}
                        onClose={() => this.popupCancelled(this.modalConstants.filterModal)}
                        fullWidth
                        header={this.labels.HubLabelFilter}
                        dialogContent=
                        {
                            <>
                                <div className="row">
                                    <IbssInputDropDown
                                        options={filterStatusOption}
                                        id="statusSelection"
                                        value={this.state.statusValue}
                                        inputLabel={this.labels.HubLabelStatus}
                                        fullWidth
                                        onChange={(event: SelectChangeEvent<string>) => { this.setState({ statusValue: event.target.value }) }}
                                    />
                                </div>
                            </>
                        }
                        footer=
                        {
                            <Box gap={2} display={'flex'}>
                                <IbssButtonRedo
                                    onClick={() => this.popupCancelled(this.modalConstants.filterModal)}
                                    color="secondary"
                                    variant="outlined"
                                >
                                    {this.labels.HubButtonCancel}
                                </IbssButtonRedo>
                                <IbssButtonRedo
                                    color="primary"
                                    variant="contained"
                                    size="medium"
                                    onClick={() => this.popupSubmitted(this.modalConstants.filterModal)}
                                >
                                    {this.labels.HubLabelOk}
                                </IbssButtonRedo>
                            </Box>
                        }
                    />
                    <div className="">
                        {this.state.loading && <Spinner />}
                        <div className="rightPanel-main-content">
                            <div className="table-panel">
                                <IbssFilterHeader
                                    title={this.labels.HubMenuTasks}
                                    selectedPreset={this.state.daysFilter}
                                    presetChanged={(e) => this.dateRangeChanged(e)}
                                    startDate={this.state.startDate.toJSDate()}
                                    endDate={this.state.endDate.toJSDate()}
                                    datesDisabled={this.state.dateDisabled}
                                    onStartDateChange={i => this.startDateChanged(i)}
                                    onEndDateChange={i => this.endDateChanged(i)}
                                    presets={[this.labels.HubLabelThisWeek, this.labels.HubLabelThisMonth, this.labels.funcLastMonth_S]}
                                />
                                <IbssFilter
                                    showExport={!this.isFlex && this.state.canExport}
                                    searchTerm={this.state.searchTerm}
                                    onSearchTermChange={(event) => this.searchTermChange(event)}
                                    onFilterButtonClick={() => this.setState({ openFilterModal: true })}
                                    onExportButtonClick={() => { this.exportTaskList() }}
                                    disableExport={this.state.disableExport}
                                />
                                <Box sx={visuallyHidden}>
                                    <Typography aria-live="polite">
                                        {filteredTasks.pages.length > 0 ? `${filteredTasks.pages.length} ${this.labels.funcResultsFound_S}` : `${this.labels.funcNoResultsFound_S}`}
                                    </Typography>
                                </Box>
                                <Box component="div" sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center', my: 1, mr: 0 }}>
                                    <IbssActionButton
                                        buttons={this.isFlex ? taskRaisedActionButtons : actionButtons}
                                    />
                                </Box>
                                <Box sx={{ mt: 1 }}>
                                    <ServerDataGrid
                                        ref={this.dataGridRef}
                                        getRowId={(row) => row.Task_Id}
                                        loadDataOnMount={false}
                                        checkboxSelection
                                        columns={this.isFlex ? taskRaisedGridHeader : dataGridHeader}
                                        disableRowSelectionOnClick
                                        pageSizeOptions={[100]}
                                        pages={this.state.searchTerm.length > 0 ? filteredTasks : this.state.pagesOfTask}
                                        onDataQueryChange={i => this.dataQueryChanged(i)}
                                        onPagesChange={pages => this.setStateAsync({ pagesOfTask: pages })}
                                        onRowSelectionModelChange={(rowSelectionModel: GridRowSelectionModel) => this.tasksSelected(rowSelectionModel)}
                                        sortModel={[ { field: 'Task_Due_Date', sort: 'desc' } ]}
                                    />
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    private renderTaskPriority(value: number): React.ReactNode
    {
        let priority = "-";
        if (value === 0)
        {
            priority = priority;
        }
        else if (value === 1)
        {
            priority = this.labels.HubLabelHighPriority;
        }
        else if (value === 2)
        {
            priority = this.labels.HubLabelNormalPriority;
        }
        else if (value === 3)
        {
            priority = this.labels.HubLabelLowPriority;
        }
        return priority;
    }

    private renderTaskAction(value: string, taskId: string, floorId: string): React.ReactNode
    {
        let status = "-";
        let disabled = true;

        if (value === "Active" && !this.isFlex)
        {
            status = this.labels.HubButtonAssign;
            disabled = !this.state.isAssignRight;
        }
        else if (value === "Awaiting Re-allocation" && this.isFlex)
        {
            status = this.labels.HubButtonAssign;
            disabled = !this.state.isAssignRight;
        }
        else if (value === "Assigned" && !this.isFlex)
        {
            status = this.labels.HubButtonSetInProgress;
            disabled = !this.state.isSetInProgressRight;
        }
        else if (value === "In Progress" && !this.isFlex)
        {
            status = this.labels.HubLabelResolved;
            disabled = !this.state.isSetInProgressRight;
        }
        const myTasks = `/flex-my-tasks/${floorId}/mytask/${taskId}`;
        const onelensTasks = `/operational-services-tasks/${floorId}/task/${taskId}/1`;

        let navigationRoute = onelensTasks;

        if (this.isFlex)
        {
            navigationRoute = myTasks;
        }

        return (
            <>
                {value === "In Progress" ? (
                    <IbssButtonRedo
                        className="text-link"
                        disabled={disabled}
                        onClick={() => this.gridActionClicked(status, taskId)}
                    >
                        {status}
                    </IbssButtonRedo>
                ) : (
                    <IbssButtonRedo
                        className="text-link"
                        disabled={disabled}
                        onClick={() => this.gridActionClicked(status, taskId)}
                        focusRipple
                    >
                        {status}
                    </IbssButtonRedo>
                )}
                {this.state.isUpdateRight && (
                    <IbssSvgIcon
                        tabIndex={0}
                        className="pointer"
                        onClick={() => this.props.history.push(navigationRoute)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key===' ') {
                                e.preventDefault();
                                this.props.history.push(navigationRoute);
                            }
                        }}
                    >
                        <EditIcon />
                    </IbssSvgIcon>
                )}
            </>
        );
    }

}

interface IProps extends RouterProps, RouteComponentProps<IMatchParams>
{
}

interface IMatchParams 
{
    buildingid: string;
    filter: string;
}

interface IState
{
    loading: boolean;
    buildingId: number;
    taskList: ITaskView[];
    todayTaskList: ITaskView[];
    canExport: boolean;
    isCreateRight: boolean;
    isUpdateRight: boolean;
    isAssignRight: boolean;
    isUnAssignRight: boolean;
    isCancelRight: boolean;
    isReallocateRight: boolean;
    isSetInProgressRight: boolean;
    isChangePriorityRight: boolean;
    buildingid: number;
    startDate: DateTime;
    endDate: DateTime;
    openUserModal: boolean;
    openMessageModal: boolean;
    message: string;
    selectedTaskIds: GridRowSelectionModel;
    actionType: string;
    daysFilter: string;
    dateDisabled: boolean;
    searchTerm: string;
    openFilterModal: boolean;
    statusValue: string;
    disableReallocate: boolean;
    disableCancel: boolean;
    disableUnassign: boolean;
    disablePriority: boolean;
    disableInprogress: boolean;
    userSearchText: string;
    selectedUser: { label?: string, userName: string },
    openPriorityModal: boolean,
    setPriority: number;
    inProgressModal: boolean;
    disableResolved: boolean;
    isAtleastOneInProgress: boolean;
    showPreparingExportPopup: boolean;
    disableExport: boolean;
    pagesOfTask: IPages<ITaskView>;
}

export interface ITaskModal
{
    messageModal: string,
    filterModal: string,
    userSelectionModal: string,
    priorityModal: string,
}

export interface IFilter
{
    buildingid: number;
    startDate: DateTime;
    endDate: DateTime;
    statusValue?: string;
}